import * as apiRest from "./api";

export default apiRest
